import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './VipRetired.css'

// VIP ersätts av erkännandeprogrammet Sweden Stars (nedstängning av VIP i Digital Forms 2026-10-23).
const NEW_VIP_SYSTEM_NAME = 'Sweden Stars'
const NEW_VIP_SYSTEM_URL = 'https://fujitsugl.rewardgateway.com/SmartHub'

const VipRetired = ({ setTitle }) => {
  useEffect(() => {
    setTitle('VIP - Value In People')
  }, [])

  return (
    <div className='vipRetiredContainer'>
      <div className='vipRetiredCard'>
        <h3>VIP har ersatts av {NEW_VIP_SYSTEM_NAME || 'ett nytt program'}</h3>
        <p>
          Nya VIP-nomineringar kan inte längre skapas i Digital Forms.
          {NEW_VIP_SYSTEM_NAME && (
            <>
              {' '}Vill du uppmärksamma en kollega gör du det nu i vårt erkännandeprogram{' '}
              {NEW_VIP_SYSTEM_URL ? (
                <a href={NEW_VIP_SYSTEM_URL} target='_blank' rel='noreferrer'>
                  {NEW_VIP_SYSTEM_NAME}
                </a>
              ) : (
                NEW_VIP_SYSTEM_NAME
              )}
              .
            </>
          )}
        </p>
        <p>
          Redan påbörjade nomineringar hanteras klart här som vanligt.
        </p>
        <ul>
          <li>
            <Link to='/vip/ongoing'>Mina pågående VIP-ansökningar</Link>
          </li>
          <li>
            <Link to='/vip/completed'>Mina avslutade VIP-ansökningar</Link>
          </li>
          <li>
            <Link to='/'>Till startsidan</Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default VipRetired
